import React, { useEffect,useState } from 'react';

const NumberSixTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,backToTopTabData }) => {
    const [isVisible, setIsVisible] = useState(false);
                   
    const {
        is_website_frontend,
        text_title,
        button_color,
        icion_text_color,
        border_color,
        size_type,
        shape_type,
        position,
        scroll_position_to_display
    } = backToTopTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/back-to-top/temp-css/BackToTop.css`;
        if (widgetId) {
            link.setAttribute("back-to-top-data-dynamic-css", "back-to-top");
        } else {
            link.setAttribute("data-dynamic-css", "back-to-top");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="back-to-top"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    // Scroll Listener
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY >= Number(scroll_position_to_display)) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, [scroll_position_to_display]);

    // Scroll to Top Action
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <div className={`upgadeify back_to_top six-temp ${is_website_frontend}`}>
                {is_website_frontend !== "website-frontend" && (
                    <div className="back-to-top-content back-to-top-inner_image">
                        <img
                        src={`${process.env.PUBLIC_URL}/back-to-top/back-to-top-inner.png`}
                        alt="back-to-top-inner"
                        />
                    </div>
                )}
                {isVisible && (
                    <button className={`back_top_btn back_to_top_size back_top_btn_rounded ${position} ${size_type} ${shape_type}`} onClick={scrollToTop} style={{ background: button_color,borderColor: border_color }}>
                        <svg width="41" height="44" viewBox="0 0 41 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill={icion_text_color} fill-rule="evenodd" clip-rule="evenodd" d="M18.5075 1.46272C19.4161 0.554093 20.8992 0.554093 21.8078 1.46272L39.6051 19.2607C40.5152 20.1707 40.5152 21.651 39.6051 22.561L38.6096 23.5565C37.6988 24.4674 36.2192 24.4676 35.3082 23.5566L21.8082 10.0553C20.8974 9.1443 19.4175 9.1443 18.5067 10.0553L5.00659 23.5565C4.09565 24.4676 2.61621 24.4675 1.70527 23.5564L0.709731 22.5609C-0.198896 21.6523 -0.198896 20.1692 0.709731 19.2606L18.5075 1.46272ZM0.70953 38.1114C-0.200102 39.021 -0.200001 40.5027 0.70953 41.4122L1.70507 42.4078C2.6142 43.3169 4.09726 43.317 5.00649 42.4078L18.5067 28.9072C19.4176 27.9963 20.8973 27.9963 21.8082 28.9072L35.3083 42.4079C36.2177 43.3174 37.7003 43.3173 38.6097 42.4079L39.6052 41.4123C40.5152 40.5024 40.5153 39.0215 39.6052 38.1115L23.3877 21.8945C27.9323 17.3454 26.7798 18.4961 23.3844 21.8912L21.8078 20.3147C20.8986 19.4055 19.4166 19.4056 18.5074 20.3147L0.70953 38.1114Z"/>
                        </svg>
                        <span style={{ color: icion_text_color }}>{text_title}</span>
                    </button>
                )}
            </div>
        </>
    );
};

export default NumberSixTemplateWidget;
